import {useEffect, useState} from 'react'

// Phones and tablets: no hover, and a finger instead of a mouse. Laptops with
// touch screens still report hover, so they keep desktop behaviour.
export const TOUCH_ONLY_QUERY = '(hover: none) and (pointer: coarse)'

export function useTouchOnly(): boolean {
  const [isTouchOnly, setIsTouchOnly] = useState(
    () => window.matchMedia(TOUCH_ONLY_QUERY).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(TOUCH_ONLY_QUERY)
    const update = () => setIsTouchOnly(mediaQuery.matches)
    update()
    mediaQuery.addEventListener('change', update)
    return () => mediaQuery.removeEventListener('change', update)
  }, [])

  return isTouchOnly
}
